import React from "react";
import {
    Watermark
} from "antd";

function Cjzx() {
    return <div style={{
        width: "100%",
        height: "100%"
    }}>
        <Watermark style={{
            height: "100%"
        }} content={"平台正在开发中"} />
    </div>
}

export default Cjzx